/** @module resolve */ /** for typedoc */
export * from "./interface";
export * from "./resolvable";
export * from "./resolveContext";



/** WEBPACK FOOTER **
 ** ./resolve/module.ts
 **/